import { mapCountryCodeToDefaultCurrency } from '@seek/salary-data';
import type { SalaryCurrency } from '@seek/salary-data/lib-types/types';
import { code } from 'currency-codes';

import { log } from 'src/app/utils/logging';
import type { SalaryType as SalaryTypeGraph } from 'src/graphql/generated';
import { PayType } from 'src/types/salaryTypes';
import { payTypeGraphQLToUI } from 'src/types/serializer';

const exponentForCurrency = (currency: string): number | undefined =>
  code(currency)?.digits;

export const majorToMinor = (
  currency: string | null,
  valueInMajorUnit: number | undefined,
): number | undefined => {
  if (typeof currency === 'string') {
    const exponent = exponentForCurrency(currency);

    if (exponent === undefined) {
      log.error(`${currency} is not a supported currency`);
      return undefined;
    }

    return typeof valueInMajorUnit === 'number'
      ? Math.round(valueInMajorUnit * 10 ** exponent)
      : undefined;
  }
  return undefined;
};

export const minorToMajor = (
  currency: string | null,
  valueInMinorUnit: number | undefined,
) => {
  if (typeof currency === 'string') {
    const exponent = exponentForCurrency(currency);

    if (exponent === undefined) {
      log.error(`${currency} is not a supported currency`);
      return undefined;
    }

    return typeof valueInMinorUnit === 'number'
      ? Number((valueInMinorUnit / 10 ** exponent).toFixed(exponent))
      : undefined;
  }
  return undefined;
};

export const mapSalaryTypeGraphToPayTypeUI = (
  salaryTypeGraph?: SalaryTypeGraph | null,
): PayType => {
  if (!salaryTypeGraph || !payTypeGraphQLToUI[salaryTypeGraph]) {
    log.error(
      'mapSalaryTypeGraphToPayTypeUI | Unknown Pay Type',
      {
        salaryTypeGraph,
      },
      true,
    );

    return PayType.ANNUAL_PACKAGE;
  }

  return payTypeGraphQLToUI[salaryTypeGraph];
};

export const getSalaryCurrency = ({
  formDataCurrency,
  hirerNation,
  jobLocationCountry,
}: {
  formDataCurrency: SalaryCurrency | null;
  hirerNation?: string;
  jobLocationCountry: string | null;
}): SalaryCurrency => {
  if (formDataCurrency) {
    return formDataCurrency;
  }

  return (
    mapCountryCodeToDefaultCurrency(jobLocationCountry || hirerNation) ?? 'AUD'
  );
};
